import { render, staticRenderFns } from "./StoreDetailsMap.vue?vue&type=template&id=539c9431&scoped=true&"
import script from "./StoreDetailsMap.vue?vue&type=script&lang=js&"
export * from "./StoreDetailsMap.vue?vue&type=script&lang=js&"
import style0 from "./StoreDetailsMap.vue?vue&type=style&index=0&id=539c9431&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c9431",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppExternalLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppExternalLink.vue').default,StoreMap: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/store/StoreMap.vue').default})
